/*
 * Copyright (C) 2025 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { GamificationComponent } from './gamification.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    UIRouterModule,
    SharedModule,
  ],
  declarations: [
    GamificationComponent,
  ],
  exports: [
    GamificationComponent,
  ],
})
export class GamificationModule {}
